export enum DirectOrderChannel {
  CREATE = 'directOrder::create',
  EDIT = 'directOrder::patch',
  DELETE = 'directOrder::delete',
}
